/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { HandlerGroupFactoryDeps } from 'src/core/types/handler';
import { loadEntitiesHelper } from 'src/luis/projects/entities/utils/loadCommonEntitiesHelper';

export type CommonEntityHandlerGroup = ReturnType<typeof createCommonEntityHandlerGroup>;

/**
 * Represents a handler group for common entity operations.
 *
 * @param dependencies The handler group dependencies.
 */
export const createCommonEntityHandlerGroup = (dependencies: HandlerGroupFactoryDeps) => {
    const { rootStore } = dependencies;
    const loadEntities = loadEntitiesHelper(rootStore);

    return { loadEntities };
};
